import { MobileStepperProps, RacwaStepperTemplateProps } from "@racwa/react-components";
import { EMPTY_URL, SidebarContent } from "raci-react-library";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useRoutes from "../../routing/useRoutes";
import usePage from "../usePage";

export const useStepperPage = (): RacwaStepperTemplateProps => {
  const commonPageProps = usePage();
  const { steps, activeStepIndex, navigateToPreviousStep, lockdownPreviousPage } = useRoutes();
  const navigate = useNavigate();

  const sidebarTitle = "Boat Insurance";

  const sidebarContent = useMemo(
    () => (
      <SidebarContent
        pdsUrl={process.env.REACT_APP_PDS_PED_URL || EMPTY_URL}
        feedbackUrl={process.env.REACT_APP_FEEDBACK_URL || EMPTY_URL}
      />
    ),
    [],
  );

  const mobileStepperProps: MobileStepperProps = {
    hideBack: !navigateToPreviousStep || lockdownPreviousPage,
    onClickBack: () => navigateToPreviousStep && navigateToPreviousStep(),
  };

  const onStepClick = (stepName: string, stepIndex: number) => {
    activeStepIndex !== stepIndex && navigate(steps[stepIndex].path);
  };

  return {
    sidebarTitle,
    sidebarContent,
    steps,
    activeStepIndex,
    mobileStepperProps,
    onStepClick,
    ...commonPageProps,
  };
};

export default useStepperPage;
